<template>
	<div>
		<div v-if="user.type==1">
			<div class="user_top">
				<img @click="xin.goUrl('/personalCenter/head')" :src="user.avatar"/>
				<div >
					<div class="user_name"> {{user.nickname}}</div>
					<div>您的会员级别为：<span class="user_vip">{{user.type | isVip}}</span></div>
				</div>
			</div>
			<div class="credits_num">
				<div>
					总积分数量
					<div class="cre_number">{{user.total_score | toInt}}</div>
				</div>
				<div>
					可用积分数量
					<div class="cre_number">{{user.usable_score| toInt}}</div>
				</div>
			</div>
			<div class="cre_huo">
				<div class="cur_po flex1" @click="xin.goUrl('/applyVip')"><img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/20201208103245.jpg"/></div>
				<div class="cur_po flex1" @click="xin.goUrl('/integral')"><img src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/activity2.png"/></div>
			</div>
			<p class="cre_wei">
				注：订购积分需到款后变为可用积分，以下列表显示均为可用积分情况
			</p>
			<table v-loading="loading" class="table" cellpadding="10px" >
				<thead bgcolor="#005599" >
					<th>订单编号</th>
					<th>积分变动</th>
					<th>备注</th>
					<th>失效日期</th>
				</thead>
				<tbody >
					<tr v-for="item in integral_log" :key="item.id">
						<td>{{item.out_trade_no}}</td>
						<td class="asd">{{item.type==1?'+':'-'}}{{item.integral | toInt}}</td>
						<td>{{item.note}}</td>
						<td>{{item.expire_date*1000 | timeFormat('yyyy-mm-dd')}}</td>
					</tr>
				</tbody>
			</table>
			<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
		</div>
		<!--不是vip-->

		<div v-else class="clearfloat">
			<div class="imgs flo_lf">
				<img @click="xin.goUrl('/personalCenter/head')" :src="user.avatar"/>
			</div>
			<div class="message_box flo_lf">
				<div class="user_name"> {{user.nickname}}</div>
				<div>您的会员级别为：<span class="user_vip">{{user.type | isVip}}</span></div>
				<div>您回到同仁化学中国！您的上一次登录时间：{{user.last_time*1000 | timeFormat}}</div>
				<p class="cre_title red" v-if="isVip==0">尽快申请VIP，享有订购积分！</p>
				<p class="cre_title red" v-else-if="isVip==1">您的VIP申请已收到，我们后续会尽快进行审核，并联系您!</p>
				<p class="cre_title red" v-else-if="isVip==3">很抱歉您的VIP审核未通过!</p>
				<div class="content_vip" v-html="th"></div>
				<div class="content_vip" v-html="ff"></div>
				<div class="content_vip" v-html="yq"></div>
				<button class="laing_btn" v-preventReClick @click="xin.goUrl('/applyVip')">申请VIP</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				loading:true,
				isVip:0,//vip申请过程
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
				th:"",//vip特惠
				ff:"",//VIP申请方法：
				yq:"",//VIP申请要求：
				integral_log:[],//
			}
		},
		computed:{
			...mapState(['user','token'])
		},
		created(){
				if(this.user.type==1)
					this.Postintegral_log();
				else
					this.PostuserCommon();
		},
		methods:{
			async Postintegral_log(){
				this.loading = true;
				let {data} = await this.api.Postintegral_log({page:this.pageNo});
				this.integral_log = data.data;
				this.total = data.total;
				this.limit = data.per_page;
				this.loading = false;
			},
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.Postintegral_log();
			},
			async PostuserCommon(){//不是vip
				let {data:data1} = await this.api.PostUseris_vip();
				this.isVip = data1;
				let {data} = await this.api.PostuserCommon({name:'vou_vip'});
				this.th = data;
				let {data:a} = await this.api.PostuserCommon({name:'vip_apply_way'});
				this.ff = a;
				let {data:b} = await this.api.PostuserCommon({name:'vip_apply_ask'});
				this.yq = b;
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
.feye{
	margin: 40px auto;
	display: flex;
	justify-content: center;
}
	.content_vip{
		margin-top: 30px;
	}
	.table{
		width: 100%;
		color: #333333;
		margin-top: 50px;
		.asd{
			font-size: 36px;
		}
		th{
			color: #fff;
		}
		td{
			height: 100px;
			text-align: center;
			border-bottom: 0.5px solid #D9D9D9;
		}
	}
	.cre_wei{
		font-size: 16px;
		color: #b03130;
		line-height: 30px;
	}
	.cre_huo{
		display: flex;
		// justify-content: space-between;
		margin-top: 20px;
		div:not(:first-child){
			margin-left: 10px;
		}
		img{
			
			width: 100%;
		}
	}
	.credits_num{
		margin-top: 10px;
		height: 120px;
		background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/credits_bgck.png) no-repeat;
		display: flex;
		color: #fff;
		font-size: 20px;
		justify-content: space-around;
		align-items: center;
		
		.cre_number{
			font-size: 36px;
			text-align: center;
		}
	}
	.user_top{
		display: flex;
		align-items: center;
		
		img{
			cursor: pointer;
			width: 100px;
			height: 100px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
	
</style>
